import { LINKS } from "enums/userExtensions";

export const CUSTOM_LINKS_COUNT = 3;

export const LINK_PROPERTIES = {
  [LINKS.DISCORD]: {
    name: "Discord",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/discord.svg`,
  },
  [LINKS.FACEBOOK]: {
    name: "Facebook",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/facebook.svg`,
  },
  [LINKS.INSTAGRAM]: {
    name: "Instagram",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/instagram.svg`,
  },
  [LINKS.LINKEDIN]: {
    name: "LinkedIn",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/linkedin.svg`,
  },
  [LINKS.MEDIUM]: {
    name: "Medium",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/medium.svg`,
  },
  [LINKS.OPENSEA]: {
    name: "OpenSea",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/opensea.svg`,
  },
  [LINKS.TELEGRAM]: {
    name: "Telegram",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/telegram.svg`,
  },
  [LINKS.TIKTOK]: {
    name: "TikTok",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/tiktok.svg`,
  },
  [LINKS.TWITCH]: {
    name: "Twitch",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/twitch.svg`,
  },
  [LINKS.X]: {
    name: "X",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/x.svg`,
  },
  [LINKS.WEBSITE]: {
    name: "Website",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/website.svg`,
  },
  [LINKS.YOUTUBE]: {
    name: "YouTube",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/youtube.svg`,
  },
  [LINKS.WARPCAST]: {
    name: "Warpcast",
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/warpcast.png`,
  },
  [LINKS.CUSTOM]: {
    icon: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/socials/custom.svg`,
  },
};
